/*
 * @Author: shuchang
 * @Date: 2022-03-21 14:42:00
 * @LastEditors: shuchang
 * @LastEditTime: 2022-03-22 09:59:58
 * @Description: 
 */
import Vue from 'vue';

// 使用 Event Bus
const bus = new Vue();

export default bus;